import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { CopyUrlButton } from '../CopyUrlButton';
import { AddFirmwareState } from './useAddFirmware';

/** Where the image is served from, its size and its checksum (prefilled by the upload). */
export const FirmwareFileSection: React.FC<{ state: AddFirmwareState }> = ({ state }) => {
  const { t } = useI18n();
  const { form, errors, submitting } = state;

  return (
    <div className="device-section">
      <h3 className="section-title">{t('otaUpdates.fileDetails')}</h3>
      <div className="file-details-fields">
        <div className="form-field form-field-full">
          <label className="required">{t('otaUpdates.fileUrl')}</label>
          <div className="url-input-group">
            <input
              type="text"
              data-testid="field-firmware-file-url"
              value={form.file_url}
              onChange={(e) => state.setField('file_url', e.target.value)}
              placeholder={t('otaUpdates.fileUrlPlaceholder')}
              disabled={submitting}
              className={`field-input ${errors.file_url ? 'error' : ''}`}
              maxLength={500}
            />
            {form.file_url && <CopyUrlButton url={form.file_url} />}
          </div>
          {errors.file_url && <span className="field-error">{errors.file_url}</span>}
        </div>

        <div className="form-field">
          <label>{t('otaUpdates.fileSizeBytes')}</label>
          <input
            type="text"
            value={form.file_size}
            onChange={(e) => state.setField('file_size', e.target.value)}
            placeholder={t('otaUpdates.fileSizeExample')}
            disabled={submitting}
            className={`field-input ${errors.file_size ? 'error' : ''}`}
          />
          {errors.file_size && <span className="field-error">{errors.file_size}</span>}
        </div>

        <div className="form-field">
          <label>{t('otaUpdates.checksumSha256')}</label>
          <input
            type="text"
            value={form.checksum}
            onChange={(e) => state.setField('checksum', e.target.value)}
            placeholder={t('otaUpdates.sha256Placeholder')}
            disabled={submitting}
            className="field-input"
            maxLength={100}
          />
        </div>
      </div>
    </div>
  );
};
